import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "email-subject"
}
const _hoisted_2 = {
  key: 0,
  style: {"color":"#808080","display":"flex","justify-content":"center"}
}
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "email-info" }
const _hoisted_5 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_6 = { style: {"flex-grow":"1"} }
const _hoisted_7 = {
  key: 0,
  class: "info-section"
}
const _hoisted_8 = { class: "attachments" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "body-section" }
const _hoisted_11 = { class: "recipients-table table table-striped" }
const _hoisted_12 = ["rowspan"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["rowspan"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShadowDom = _resolveComponent("ShadowDom")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalWindow, {
      class: "email-modal",
      show: _ctx.show,
      onClose: _cache[1] || (_cache[1] = ($event: any) => {_ctx.error = false; _ctx.showRecipients = false; _ctx.$emit('close');})
    }, {
      title: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
          : (_ctx.error || _ctx.email === null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Error")
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.email.subject), 1))
      ]),
      body: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "fa fa-spinner fa-pulse fa-10x" }, null, -1)
            ])))
          : (_ctx.error || _ctx.email === null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Error loading email.")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-type" }, "Sent At", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTime(new Date(_ctx.email.createdAt * 1000))), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info-type" }, "From", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.email.from), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-type" }, "Recipients", -1)),
                    _createElementVNode("span", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.recipientsString), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-info",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRecipients = true))
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "fas fa-table" }, null, -1)
                      ]))
                    ])
                  ])
                ]),
                (_ctx.email.attachments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[8] || (_cache[8] = _createElementVNode("strong", { class: "info-type" }, "Attachments", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.email.attachments, ({id, filename}, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: id }, [
                            _createElementVNode("a", {
                              href: `/email/${_ctx.email.id}/attachment/${id}`
                            }, _toDisplayString(filename), 9, _hoisted_9),
                            (i < _ctx.email.attachments.length - 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(", ")
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ShadowDom, {
                    html: _ctx.email.body,
                    class: "email-body"
                  }, null, 8, ["html"])
                ])
              ], 64))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ModalWindow, {
      class: "recipients-modal",
      show: _ctx.show && _ctx.showRecipients && _ctx.email !== null,
      onClose: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showRecipients = false;}),
      backdropZIndex: "1070",
      modalZIndex: "1075"
    }, {
      title: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode("Recipients")
      ])),
      body: _withCtx(() => [
        _createElementVNode("table", _hoisted_11, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Rule"),
              _createElementVNode("th", null, "Group"),
              _createElementVNode("th", null, "Recipient")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.email?.recipients, (recipientsForRule) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: [recipientsForRule.rule?.id, recipientsForRule.group?.id]
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    rowspan: recipientsForRule.recipients.length
                  }, [
                    (recipientsForRule.rule !== null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.permissions.editRule)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                target: "_blank",
                                href: `/rule/${recipientsForRule.rule.id}/edit?email_id=${_ctx.email?.id}`
                              }, _toDisplayString(recipientsForRule.rule.name), 9, _hoisted_13))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(recipientsForRule.rule.name), 1)
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_12),
                  _createElementVNode("td", {
                    rowspan: recipientsForRule.recipients.length
                  }, [
                    (recipientsForRule.group !== null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.permissions.editGroup)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                target: "_blank",
                                href: `/group/${recipientsForRule.group.id}/edit`
                              }, _toDisplayString(recipientsForRule.group.name), 9, _hoisted_15))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(recipientsForRule.group.name), 1)
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_14),
                  _createElementVNode("td", null, [
                    (_ctx.permissions.editRecipient)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          target: "_blank",
                          href: `/recipient/${recipientsForRule.recipients[0]?.id}/edit`
                        }, _toDisplayString(recipientsForRule.recipients[0]?.emailAddress), 9, _hoisted_16))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(recipientsForRule.recipients[0]?.emailAddress), 1)
                        ], 64))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipientsForRule.recipients.slice(1), (recipient) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: recipient.id
                  }, [
                    _createElementVNode("td", null, [
                      (_ctx.permissions.editRecipient)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            target: "_blank",
                            href: `/recipient/${recipient.id}/edit`
                          }, _toDisplayString(recipient.emailAddress), 9, _hoisted_17))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(recipient.emailAddress), 1)
                          ], 64))
                    ])
                  ]))
                }), 128))
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}